export const VALID_PROMO_CODES: string[] = [];
